var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcTokenWithdrawalWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0407 10.8667L9.92739 2.38669C9.5072 1.72935 8.78088 1.3316 8.00072 1.3316C7.22056 1.3316 6.49424 1.72935 6.07405 2.38669L0.960718 10.8667C0.593082 11.4795 0.580375 12.2419 0.927385 12.8667C1.3287 13.5701 2.07754 14.0031 2.88738 14H13.1141C13.9184 14.0086 14.6659 13.5865 15.0741 12.8934C15.4314 12.2618 15.4187 11.4862 15.0407 10.8667ZM8.00072 11.3334C7.63253 11.3334 7.33405 11.0349 7.33405 10.6667C7.33405 10.2985 7.63253 10 8.00072 10C8.36891 10 8.66739 10.2985 8.66739 10.6667C8.66739 11.0349 8.36891 11.3334 8.00072 11.3334ZM8.00072 9.33335C8.36891 9.33335 8.66739 9.03488 8.66739 8.66669V6.00002C8.66739 5.63183 8.36891 5.33335 8.00072 5.33335C7.63253 5.33335 7.33405 5.63183 7.33405 6.00002V8.66669C7.33405 9.03488 7.63253 9.33335 8.00072 9.33335Z",
    fill: "#FFAB00"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcTokenWithdrawalWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_token_Withdrawal_warning.08943a9c4c9a1ef59ff2a07e7116e8ae.svg";